function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { loginObj, validateError } from '@/services/base';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
import tasks from '@/js/tasks';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
var appApisGTW = null;
if (!configuration['master_data']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8090')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8091')
  });
}
var beforeMiddleware = function beforeMiddleware(config) {
  // tasks.getUserInfo()
  config.headers['Authorization'] = 'Bearer ' + window.userInfo.accessToken;
  return config;
};

//appApisGTW.before(beforeMiddleware)
setupInterceptors(appApisGTW);
var CONTROLLER_NAME = '/master_data';
var DOMAIN_BUSINESS_SUB = '/business_subdomain';
export default {
  getBusinessSubdomains: function getBusinessSubdomains() {
    var _this = this;
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_BUSINESS_SUB, "/get_all"), body).then(function (response) {
      return response.data;
    }).catch(function (err) {
      var message = '(businessSubdomainQuery) Search driver connection';
      var response = validateError(err, message, function () {
        _this.getBusinessSubdomains(data);
      });
      return response;
    });
  },
  businessSubdomainAddUpdate: function businessSubdomainAddUpdate() {
    var _this2 = this;
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_BUSINESS_SUB, "/businessSubdomainAddUpdate"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (err) {
      var message = '(businessSubdomainAddUpdate) Add or Update new business subdomain';
      var response = validateError(err, message, function () {
        _this2.businessSubdomainAddUpdate(data);
      });
      // const response = validateError(err, message)
      return response;
    });
  },
  businessSubdomainDelete: function businessSubdomainDelete() {
    var _this3 = this;
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_BUSINESS_SUB, "/delete"), body).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    }).catch(function (err) {
      var message = '(businessDomainDelete) Delete business domain';
      var response = validateError(err, message, function () {
        _this3.businessDomainDelete(data);
      });
      // const response = validateError(err, message)
      return response;
    });
  }
};